"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Query_1 = require("../Query");
var BaseTransform_1 = require("./BaseTransform");
var ReplaceTransform = /** @class */ (function (_super) {
    __extends(ReplaceTransform, _super);
    function ReplaceTransform() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ReplaceTransform.prototype.execute = function (queryResponse, queryOptions, executionOptions) {
        var response = queryResponse;
        if (this.options.replaceTransformOptions) {
            var replaceTransformOptions = this.options.replaceTransformOptions;
            var searchValue = replaceTransformOptions.searchValue, replaceValue = replaceTransformOptions.replaceValue, replaceQuery = replaceTransformOptions.replaceQuery, _a = replaceTransformOptions.isRegex, isRegex = _a === void 0 ? false : _a, regexFlags = replaceTransformOptions.regexFlags;
            var value = replaceValue;
            if (replaceQuery) {
                var query = new Query_1.Query(replaceQuery, this.translationHelper, (this.callStackLevel || 1) + 1);
                value = query.execute(executionOptions);
            }
            if (typeof response === 'string' && typeof searchValue === 'string' && (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean')) {
                if (isRegex) {
                    response = response.replace(new RegExp(searchValue, regexFlags), value.toString());
                }
                else {
                    response = response.split(searchValue).join(value.toString());
                }
            }
        }
        return response;
    };
    return ReplaceTransform;
}(BaseTransform_1.BaseTransform));
exports.ReplaceTransform = ReplaceTransform;
//# sourceMappingURL=ReplaceTransform.js.map